module.exports = __webpack_public_path__ + "img/user.cd242459.svg";